import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { supportUser } from "../../rbac-consts";
import { default as SuperAdminSystemCommandContainer } from "./superAdmin/SystemCommandContainer";

const SystemCommandWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={supportUser.SUPER_ADMIN}
      yes={() => (
        <SuperAdminSystemCommandContainer />
      )}
    />
  );
};

export default SystemCommandWrapper;